import axiosInstance from '@/core/api'
import type {
	CreateHotGameFlexMessageDto,
	UpdateHotGameFlexMessageDto,
	FlexMessagePresetListResponse,
	DuplicateFlexMessagePresetResponse,
} from '../../types'

class SettingsService {
	// List all flex hot games (with pagination, search, isActive filter)
	async getFlexHotGameList(params?: {
		page?: number
		pageSize?: number
		isActive?: boolean
		search?: string
	}) {
		const response = await axiosInstance.get('/admin/hot-game-flex-message', {
			params,
		})
		return response.data
	}

	// Get single flex hot game by ID
	async getFlexHotGame(id: string) {
		const response = await axiosInstance.get(
			`/admin/hot-game-flex-message/${id}`,
		)
		return response.data
	}

	// Create new flex hot game
	async createFlexHotGame(data: CreateHotGameFlexMessageDto) {
		const response = await axiosInstance.post(
			'/admin/hot-game-flex-message',
			data,
		)
		return response.data
	}

	// Update flex hot game
	async updateFlexHotGame(id: string, data: UpdateHotGameFlexMessageDto) {
		const response = await axiosInstance.patch(
			`/admin/hot-game-flex-message/${id}`,
			data,
		)
		return response.data
	}

	// Delete/disable flex hot game
	async deleteFlexHotGame(id: string) {
		const response = await axiosInstance.delete(
			`/admin/hot-game-flex-message/${id}`,
		)
		return response.data
	}

	async getFlexMessagePresets(): Promise<FlexMessagePresetListResponse> {
		const response = await axiosInstance.get<FlexMessagePresetListResponse>(
			'/admin/hot-game-flex-message/presets',
		)
		return response.data
	}

	async duplicateFlexMessagePreset(
		presetId: string,
	): Promise<DuplicateFlexMessagePresetResponse> {
		const response =
			await axiosInstance.post<DuplicateFlexMessagePresetResponse>(
				`/admin/hot-game-flex-message/presets/${presetId}/duplicate`,
			)
		return response.data
	}
}

export const settingsService = new SettingsService()
